import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import {
  enhanceCommentFailure,
  enhanceCommentSuccess,
  enhanceFeedFailure,
  enhanceFeedSuccess,
  kudosAiSuggestFailure,
  kudosAiSuggestSuccess,
} from "./actions";
import { ENHANCE_COMMENT, ENHANCE_FEED, KUDOS_AI_SUGGEST } from "./constants";

export function* enhanceCommentSaga({ payload }) {
  const token = process.env.REACT_APP_CUSTOMER_API_KEY;
  const { data, onSuccess } = payload;
  try {
    const response = yield call(
      api(token).post,
      `/api/survey/comment/polish`,
      data,
    );
    yield put(enhanceCommentSuccess());
    typeof onSuccess === "function" && onSuccess(response?.data);
  } catch (e) {
    yield put(enhanceCommentFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* enhanceFeedSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { data } = payload;
  try {
    const response = yield call(api(token).post, `/api/feed/ai-enhance`, data);
    yield put(enhanceFeedSuccess());
    typeof onSuccess === "function" && onSuccess(response?.data);
  } catch (e) {
    yield put(enhanceFeedFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* enhanceCommentFlow() {
  yield takeEvery(ENHANCE_COMMENT, enhanceCommentSaga);
}

export function* enhanceFeedFlow() {
  yield takeEvery(ENHANCE_FEED, enhanceFeedSaga);
}

export function* kudosAiSuggestSaga(action) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { payload, onSuccess } = action;
  try {
    const response = yield call(
      api(token).post,
      `/api/feed/kudos/ai-suggest`,
      payload.data,
    );
    yield put(kudosAiSuggestSuccess());
    typeof onSuccess === "function" && onSuccess(response?.data);
  } catch (e) {
    yield put(kudosAiSuggestFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* kudosAiSuggestFlow() {
  yield takeEvery(KUDOS_AI_SUGGEST, kudosAiSuggestSaga);
}

export default function* AISaga() {
  yield all([enhanceCommentFlow(), enhanceFeedFlow(), kudosAiSuggestFlow()]);
}
